import * as swcHelpers from '@swc/helpers';
import { Types } from '@grandvisionhq/graphql';
import { getLocalizedString, getLocalizedStrings, isNil } from '@grandvisionhq/utils';
import { toBaseLineItem } from './base-line-item.js';

const toEyeSide = (eyeSide)=>{
    switch(eyeSide){
        case Types.EyeSide.LEFT:
            return 'left';
        case Types.EyeSide.RIGHT:
            return 'right';
        case Types.EyeSide.BOTH:
            return 'both';
    }
};
const toEyeSideLabelKey = (eyeSide)=>{
    switch(eyeSide){
        case Types.EyeSide.LEFT:
            return 'products.contactLenses.leftEye';
        case Types.EyeSide.RIGHT:
            return 'products.contactLenses.rightEye';
        case Types.EyeSide.BOTH:
            return undefined;
    }
};
const toEyePrescription = (prescription)=>{
    return {
        addition: isNil(prescription === null || prescription === void 0 ? void 0 : prescription.addition) ? null : prescription.addition,
        axis: isNil(prescription === null || prescription === void 0 ? void 0 : prescription.axis) ? null : prescription.axis,
        baseCurve: isNil(prescription === null || prescription === void 0 ? void 0 : prescription.baseCurve) ? null : prescription.baseCurve,
        cylinder: isNil(prescription === null || prescription === void 0 ? void 0 : prescription.cylinder) ? null : prescription.cylinder,
        diameter: isNil(prescription === null || prescription === void 0 ? void 0 : prescription.diameter) ? null : prescription.diameter,
        dominance: isNil(prescription === null || prescription === void 0 ? void 0 : prescription.dominance) ? null : prescription.dominance,
        power: isNil(prescription === null || prescription === void 0 ? void 0 : prescription.power) ? null : prescription.power
    };
};
// This is used on the My Account Orders overview page
const toContactLensesOrderLineItem = (orderLineItem, intl, options = {})=>{
    const { eyeSide , prescription  } = orderLineItem;
    const { boxQuantity , colors , replacementFrequency  } = orderLineItem.product;
    const eyeSideLabelKey = toEyeSideLabelKey(eyeSide);
    const replacementFrequencyLabel = getLocalizedString(replacementFrequency, intl.locale);
    const colorValues = getLocalizedStrings(colors, intl.locale);
    const colorLabel = `${intl.getLabel('products.lensColor')}: ${colorValues.join(', ')}`;
    const unit = intl.getLabel('products.unit.contactLenses');
    const eyeSideLabel = eyeSideLabelKey ? intl.getLabel(eyeSideLabelKey) : undefined;
    let perBox = intl.getLabel('products.perBox');
    perBox = eyeSideLabelKey ? `${perBox},` : perBox;
    const subtitle = [
        boxQuantity,
        replacementFrequencyLabel,
        unit,
        perBox,
        eyeSideLabel
    ].filter(Boolean).join(' ');
    return swcHelpers.objectSpread({}, toBaseLineItem(orderLineItem, intl, options), {
        type: 'CONTACT_LENSES',
        productType: 'contact-lenses',
        subtitle,
        eyeSide: toEyeSide(eyeSide),
        prescription: toEyePrescription(prescription),
        isSubscription: orderLineItem.isSubscription,
        subscriptionDetails: orderLineItem.subscriptionDetails || undefined,
        additionalInfo: colorValues.length ? [
            colorLabel
        ] : undefined
    });
};

export { toContactLensesOrderLineItem };
//# sourceMappingURL=contact-lenses-line-item.js.map
